import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "./../index";
import { Animated } from "react-animated-css";
import { Button, Form, Input, Checkbox, Radio } from "antd";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import md5 from "md5";
import qs from "qs";
import moment from "moment";
import Helper from "./../../../extra/helper";
import Chitiet from "./../../../assets/suc-khoe-vang/chitiet.png";
import Iticket from "./../../../assets/suc-khoe-vang/ticket.png";
import Iedit from "./../../../assets/suc-khoe-vang/iedit.png";
import IViewDetail from "./../../../assets/suc-khoe-vang/viewDetail.png";
import ModalVat from "./../modal/modalvat";
import ModalViewDetail from "./../modal/modalViewDetail";
import Chevronmo from "./../../../assets/suc-khoe-vang/chevronmo.png";
import Chevrondong from "./../../../assets/suc-khoe-vang/chevrondong.png";
import Ivat from "./../../../assets/suc-khoe-vang/ivat.png";
import IvatTrue from "./../../../assets/suc-khoe-vang/ivattrue.png";
import Signater from "./signature";
import ModalBenifitDetails from "./../modal/modalBenifitsDetail";
import Service from "./../../../extra/getAPI";
import MdDone from "./../modal/modaldone";
import LinkView from "./../modal/linkView";
import IconArrow from "../../../assets/arrow-up-sm.svg";
import { CloseOutlined } from "@ant-design/icons";

const Create = () => {
  const {
    OpenLink,
    dataIsu,
    listIsu,
    _render_quan_he,
    goStep,
    linkIMG,
    MessageErr,
    fees,
    setFees,
    vat,
    packages,
    setVAT,
    setDataIsu,
    arrItem,
    commission,
    setCommission,
    getAdditional,
    dataGetFees,
    subsidyAmount,
    setSubsidyAmount
  } = useContext(AuthContext);
  const [form] = Form.useForm();
  const formRef = React.createRef();
  const platform = Helper.getParamUrlByKey("platform");

  const [collaboratorInfo, setCollaboratorInfo] = useState(null);

  const extractToken = () => {
    let t = Helper.getParamUrlByKey("token");
    if (!t && window.location.pathname) {
      const parts = window.location.pathname.split("/").filter(Boolean);
      const lastPart = parts[parts.length - 1];
      if (lastPart) {
        if (lastPart.includes(".")) {
          t = lastPart.split(".").pop();
        } else {
          t = lastPart;
        }
      }
    }
    return t;
  };

  const token = extractToken();

  useEffect(() => {
    const fetchCollaboratorInfo = async () => {
      try {
        const t = extractToken();
        if (!t) return;

        const SERVER_OPEN = process.env.REACT_APP_SERVER_OPEN_API || 'https://open-api-dev.globalcare.vn';
        const stimeRes = await axios.get(`${SERVER_OPEN}/v1/products/stime`, {
          headers: { Authorization: `bearer ${t}` }
        });
        if (!stimeRes?.data?.success) return;

        const stime = stimeRes.data.data.stime;
        const env = process.env.REACT_APP_NODE_ENV || "";

        const sortObjectByKey = (obj) => {
          const sortedKeys = Object.keys(obj).sort();
          const sortedObject = {};
          sortedKeys.forEach((key) => {
            sortedObject[key] = obj[key];
          });
          return sortedObject;
        };

        const data_ = qs.stringify(sortObjectByKey({}));
        const uuid = uuidv4();
        const client = md5(env + '-' + data_ + stime + uuid);
        const headers = {
          Authorization: `bearer ${t}`,
          'x-api-stime': stime,
          'x-api-nonce': uuid,
          'x-api-client': client,
        };

        const response = await axios.get(`${SERVER_OPEN}/v1/products/collaborator-detail`, { headers });
        if (response?.data?.success) {
          setCollaboratorInfo(response.data.data);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchCollaboratorInfo();
  }, []);
  const showReward = Helper.getParamUrlByKey("reward") === "true";
  const [formData, setFormData] = useState({});
  const [openVat, setOpenVat] = useState(false);
  const [openViewDetail, setOpenViewDetail] = useState(false);
  const [indexDetail, setIndexDetail] = useState(null);
  const [clear, setClear] = useState(false);
  const [openBenifits, setOpenBenifits] = useState(false);
  const [indexBenifits, setindexBenifits] = useState(null);
  const [openLink, setOpenLink] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reward, setReward] = useState(0);
  const [dataVat] = useState(
    JSON.parse(localStorage.getItem("vatskv")) || null
  );
  const [errRedeem, setErrRedeem] = useState(null);
  const [openDone, setOpenDone] = useState(false);
  const [dataOrder, setDataOrder] = useState({});
  const [subsidy, setSubsidy] = useState(0);
  const [isMaxSubsidy, setIsMaxSubsidy] = useState(false);
  const [close, setClose] = useState({
    quyenloi: true,
    nguoimua: true,
    nguoiduocBH: true,
    vat: true,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    getCommission();
    showReward && getBalance();
    if (dataIsu) {
      const { vat: _vat, ...restDataIsu } = dataIsu;
      form.setFieldsValue(restDataIsu);
    }
  }, []);

  const totalFeesListIsu = () => {
    let total = 0;
    listIsu.map(
      (v) => (total = total + +v?.packages[+dataIsu?.packageId - 1]?.fees)
    );

    return total || 0;
  };

  const onFinish = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        if (!listIsu || listIsu.length === 0) {
          MessageErr("Danh sách người được bảo hiểm không được để trống!");
          return;
        }
        if (!linkIMG?.signature) {
          window.scrollTo(3000, 3000);
          MessageErr("Vui lòng ký tên để tiếp tục đơn hàng!");
          return;
        }
        if (values.vat === 2 && !vat?.name) {
          MessageErr("Vui lòng nhập thông tin xuất hoá đơn!");
          return;
        }
        createOrder();
      })
      .catch((err) => {
        console.error("err:", err);
      });
  };

  // Lấy hoa hồng
  const getCommission = async () => {
    if (!listIsu || listIsu.length === 0) {
      return;
    }
    setLoading(true);
    const data = {
      reward: showReward ? 1 : undefined,
      insuredInfo: {
        buyerName: dataIsu?.buyerName,
        buyerDob: dataIsu?.buyerDob,
        buyerGender: dataIsu?.buyerGender,
        package: dataIsu?.packageId,
      },
      listOfInsuredPeople: getListIsu(),
    };
    await Service.apicallNoBase64("POST", `/api/v1/product/58/commission`, data)
      .then((res) => {
        setLoading(false);
        if (res?.data?.statusCode === 200) {
          setCommission(+res?.data?.result?.commission);
          setSubsidyAmount(+res?.data?.result?.subsidyAmount || 0);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const getBalance = () => {
    setLoading(true);
    Service.apicallNoBase64("GET", `/api/v1/wallet/reward/balance`)
      .then((res) => {
        setLoading(false);
        if (res?.data?.statusCode === 200) {
          const balance = res?.data?.result?.wallet?.balance || 0;
          const newBalance =
            arrItem[dataIsu.packageId - 1].fee > balance
              ? balance
              : arrItem[dataIsu.packageId - 1].fee;
          setReward(newBalance);
        }
      })
      .catch((res) => {
        MessageErr(`${res?.message || "Có lỗi xảy ra"}`);
        setLoading(false);
      });
  };

  const getListIsu = () => {
    let arrInsu = [];
    listIsu.map((value) => {
      let additional = getAdditional(dataGetFees, value);
      arrInsu = [
        ...arrInsu,
        {
          insuredName: value?.insuredName,
          relationshipWithBuyer: {
            id: value?.relationshipWithBuyerName,
            title: _render_quan_he(value?.relationshipWithBuyerName),
          },
          insuredDob: value?.insuredDob.split("/").reverse().join("-"),
          insuredPrivateId: value?.insuredPrivateId,
          insuredGender: value?.insuredGender,
          insuredPhone: value?.insuredPhone,
          insuredEmail: value?.insuredEmail,
          insuredAddress: value?.permanentAddress,
          additional: additional,
        },
      ];
    });
    return arrInsu;
  };

  // Tạo đơn
  const createOrder = () => {
    const insuredList = getListIsu();
    if (!insuredList || insuredList.length === 0 || !listIsu || listIsu.length === 0) {
      setLoading(false);
      MessageErr("Danh sách người được bảo hiểm không được để trống!");
      return;
    }
    // let reDeem = dataCheckReDeem?.code;
    setLoading(true);
    let platform = Helper.getParamUrlByKey("platform");
    let staff_id = Helper.getParamUrlByKey("staff_id");
    let optional_partner = Helper.getParamUrlByKey("optional_partner");
    let datavat = JSON.parse(localStorage.getItem("vatVBICare"));
    let partnerStaffId;
    let optionalPartner;
    let redeemCode;
    let vatInfo;
    // if (reDeem) {
    //   redeemCode = reDeem;
    // }
    if (staff_id) {
      partnerStaffId = staff_id;
    }
    if (optional_partner) {
      optionalPartner = optional_partner;
    }
    if (datavat) {
      vatInfo = datavat;
    }
    let data = {
      productCode: "vbi-care",
      productId: 58,
      redeemCode,
      reward: showReward ? 1 : undefined,
      appliedCommissionAmount: subsidy,
      insuredInfo: {
        buyerName: dataIsu?.buyerName,
        buyerDob: dataIsu?.buyerDob,
        buyerGender: dataIsu?.buyerGender,
        buyerPhone: dataIsu?.buyerPhone,
        buyerPrivateId: dataIsu?.buyerPrivateId,
        buyerEmail: dataIsu?.buyerEmail,
        buyerAddress: dataIsu?.address || dataIsu?.buyerAddress,
        package: dataIsu?.packageId,
        partnerStaffId,
        optionalPartner,
        vatInfo,
        signature: linkIMG?.signature,
        beginDate: moment(dataIsu?.beginDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
        affArticleUid: Helper.getParamUrlByKey("aff_article_uid") || undefined
      },
      listOfInsuredPeople: getListIsu(),
    };
    data = JSON.stringify(data);

    if (platform === "app") {
      Service.apicallNoBase64("POST", `/api/v1/order/add-to-cart`, data)
        .then((res) => {
          setLoading(false);
          let data = res?.data;
          if (data?.statusCode === 200) {
            OpenDone();
            setDataOrder(data.result);
            CustomResetLocalStorage();
          } else {
            MessageErr("Tạo đơn hàng không thành công vui lòng thử lại!");
            // setclickButton(false);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          MessageErr("Tạo đơn hàng không thành công vui lòng thử lại!");
          // setclickButton(false);
        });
    } else {
      Service.apicallNoBase64(
        "POST",
        `/api/v1/order/create?callback=${encodeURIComponent(
          window.location.href
        )}`,
        data
      )
        .then((res) => {
          let data = res?.data;
          if (data.statusCode === 200) {
            OpenDone();
            setDataOrder(data.result);
            CustomResetLocalStorage();
          } else {
            MessageErr("Tạo đơn hàng không thành công vui lòng thử lại!");
            // setclickButton(false);
            setLoading(false);
          }
        })
        .catch((err) => {
          MessageErr("Tạo đơn hàng thất bại vui lòng thử lại!");
          // setclickButton(false);
          setLoading(false);
        });
    }
  };

  const CustomResetLocalStorage = () => {
    localStorage.removeItem("vatskv");
    localStorage.removeItem("listInsuredSKV");
    localStorage.removeItem("dataIsuskv");
  };

  const onChangForm = ({ data, name }) => {
    setFormData({
      ...formData,
      [name]: data,
    });
  };

  const openDetailBenifits = (index) => {
    setOpenBenifits(true);
    setindexBenifits(index);
  };

  const handCancel = () => {
    setOpenVat(false);
    setOpenViewDetail(false);
    setIndexDetail(null);
    setOpenBenifits(false);
    setOpenLink(false);
  };

  const OpenDone = () => {
    setOpenDone(!openDone);
  };

  return (
    <>
      <LinkView
        title={"Điều kiện, điều khoản"}
        isModalVisible={openLink}
        handleCancel={handCancel}
        url={
          "https://cdn.globalcare.vn/private/document/pdf/vbi-cares/vietinbank/Quy_tac_BH_VBI_care.pdf"
        }
      />
      <ModalBenifitDetails
        showPacked={true}
        open={openBenifits}
        handleCancel={handCancel}
      />
      {openDone && <MdDone dataOrder={dataOrder} OpenDone={OpenDone} />}
      <ModalViewDetail
        index={indexDetail}
        open={openViewDetail}
        handleCancel={handCancel}
        orderExtension={false}
      />
      <ModalVat isModalVisible={openVat} handleCancel={handCancel} />
      <Form
        style={{ fontSize: 14, color: "#343A40", overflow: "hidden" }}
        ref={formRef}
        form={form}
        onFinish={onFinish}
        name="step3skv"
        scrollToFirstError
      >
        <div style={{ padding: 10 }}>
          <div style={css.title}>Quyền lợi bảo hiểm</div>
          <div style={{ ...css.title, color: "#343A40", marginTop: 10 }}>
            <div>
              {listIsu[0]?.insuredName}
              <img
                onClick={() => goStep(2)}
                style={{ width: 15, marginLeft: 5 }}
                src={Iedit}
                alt="Global Care"
              />
            </div>
            <img
              onClick={() => setClose({ ...close, quyenloi: !close.quyenloi })}
              style={{ width: 12, marginLeft: 5 }}
              src={close.quyenloi ? Chevrondong : Chevronmo}
              alt="Global Care"
            />
          </div>
          <div>
            <div
              style={{
                display: "flex",
                marginTop: 10,
                justifyContent: "space-between",
              }}
            >
              <div style={{ color: "#646D69" }}>Gói bảo hiểm:</div>
              <div
                style={{ width: "45%", textAlign: "right", fontWeight: 500 }}
              >
                {arrItem[dataIsu.packageId - 1].title}
              </div>
            </div>
            <div style={{ display: close.quyenloi ? "" : "none" }}>
              <div style={{ display: "flex", marginTop: 10 }}>
                <div style={{ color: "#646D69", textAlign: "justify" }}>
                  Bảo hiểm tử vong, thương tật toàn bộ vĩnh viễn do tai nạn
                </div>
                <div style={{ width: "60%", textAlign: "right" }}>
                  <div style={{ fontWeight: 500, color: "#383D3B" }}>
                    {Helper.Benefits[dataIsu.packageId - 1].ql1} VNĐ
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", marginTop: 10 }}>
                <div style={{ color: "#646D69", textAlign: "justify" }}>
                  Bảo hiểm tử vong, thương tật toàn bộ vĩnh viễn do bệnh
                </div>
                <div style={{ width: "60%", textAlign: "right" }}>
                  <div style={{ fontWeight: 500, color: "#383D3B" }}>
                    {Helper.Benefits[dataIsu.packageId - 1].ql2} VNĐ
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  marginTop: 10,
                  justifyContent: "space-between",
                }}
              >
                <div style={{ color: "#646D69" }}>Chi phí y tế do tai nạn:</div>
                <div style={{ width: "60%", textAlign: "right" }}>
                  <div style={{ fontWeight: 500, color: "#383D3B" }}>
                    {Helper.Benefits[dataIsu.packageId - 1].ql3} VNĐ
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  marginTop: 10,
                  justifyContent: "space-between",
                }}
              >
                <div style={{ color: "#646D69", textAlign: "justify" }}>
                  Bảo hiểm điều trị nội trú, phẫu thuật do bệnh
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                  <div style={{ fontWeight: 500, color: "#383D3B" }}>
                    {Helper.Benefits[dataIsu.packageId - 1].ql4} VNĐ
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  marginTop: 10,
                  justifyContent: "space-between",
                }}
              >
                <div style={{ color: "#646D69" }}>Thời hạn bảo hiểm:</div>
                <div
                  style={{
                    minWidth: "45%",
                    textAlign: "right",
                    fontWeight: 500,
                  }}
                >
                  {`${dataIsu.beginDate} -
                ${moment(dataIsu.beginDate, "DD/MM/YYYY")
                      .add(1, "year")
                      .format("DD/MM/YYYY")}`}
                </div>
              </div>
              <div
                style={{ color: "#009B4B", textDecoration: "underline" }}
                onClick={() => openDetailBenifits(4)}
              >
                <i>Xem chi tiết quyền lợi bảo hiểm</i>
                <img
                  style={{ width: 6, marginLeft: 5 }}
                  src={Chitiet}
                  alt="Global Care"
                />
              </div>
            </div>
          </div>
        </div>
        <div style={css.driver}></div>
        <div style={{ padding: 10 }}>
          <div style={css.title}>
            <div>
              Thông tin người mua BH
              <img
                onClick={() => goStep(3)}
                style={{ width: 15, marginLeft: 5 }}
                src={Iedit}
                alt="Global Care"
              />
            </div>
            <img
              onClick={() => setClose({ ...close, nguoimua: !close.nguoimua })}
              style={{ width: 12, marginLeft: 5 }}
              src={close.nguoimua ? Chevrondong : Chevronmo}
              alt="Global Care"
            />
          </div>
          <div>
            <div style={css.item}>
              <div style={{ color: "#646D69" }}>Họ và tên:</div>
              <div
                style={{
                  fontWeight: 500,
                  textTransform: "capitalize",
                  textAlign: "right",
                }}
              >
                {dataIsu?.buyerName}
              </div>
            </div>
            <div style={css.item}>
              <div style={{ color: "#646D69" }}>Ngày sinh:</div>
              <div
                style={{
                  fontWeight: 500,
                  textTransform: "capitalize",
                  textAlign: "right",
                }}
              >
                {dataIsu?.buyerDob}
              </div>
            </div>
            <div style={css.item}>
              <div style={{ color: "#646D69" }}>
                Số CCCD/ Hộ chiếu:
              </div>
              <div
                style={{
                  fontWeight: 500,
                  textTransform: "capitalize",
                  textAlign: "right",
                }}
              >
                {dataIsu?.buyerPrivateId}
              </div>
            </div>
            <div style={{ display: close.nguoimua ? "" : "none" }}>
              <div style={css.item}>
                <div style={{ color: "#646D69" }}>Giới tính:</div>
                <div
                  style={{
                    fontWeight: 500,
                    textTransform: "capitalize",
                    textAlign: "right",
                  }}
                >
                  {dataIsu?.buyerGender === 1 ? "Nam" : "Nữ"}
                </div>
              </div>
              <div style={css.item}>
                <div style={{ color: "#646D69" }}>Số điện thoại:</div>
                <div
                  style={{
                    fontWeight: 500,
                    textTransform: "capitalize",
                    textAlign: "right",
                  }}
                >
                  {dataIsu?.buyerPhone}
                </div>
              </div>
              <div style={css.item}>
                <div style={{ color: "#646D69" }}>Email:</div>
                <div
                  style={{
                    fontWeight: 500,
                    textAlign: "right",
                  }}
                >
                  {dataIsu?.buyerEmail}
                </div>
              </div>
              <div style={css.item}>
                <div style={{ color: "#646D69", width: "150px" }}>
                  Địa chỉ thường trú:
                </div>
                <div
                  style={{
                    fontWeight: 500,
                    textTransform: "capitalize",
                    textAlign: "right",
                  }}
                >
                  {dataIsu?.buyerAddress}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={css.driver}></div>
        <div style={{ padding: 10 }}>
          <div style={css.title}>
            <div>
              Thông tin người được BH
              <img
                onClick={() => goStep(3)}
                style={{ width: 15, marginLeft: 5 }}
                src={Iedit}
                alt="Global Care"
              />
            </div>
            <img
              onClick={() =>
                setClose({ ...close, nguoiduocBH: !close.nguoiduocBH })
              }
              style={{ width: 12, marginLeft: 5 }}
              src={close.nguoiduocBH ? Chevrondong : Chevronmo}
              alt="Global Care"
            />
          </div>
          <div style={{ display: close.nguoiduocBH ? "" : "none" }}>
            {listIsu.map((data, i) => (
              <div
                key={i}
                style={{
                  marginTop: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: 7,
                  borderRadius: 5,
                  background: "#F8F9FA",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div>
                    <div
                      style={{
                        color: "#009B4B",
                        fontWeight: 500,
                        textTransform: "capitalize",
                      }}
                    >
                      {data.insuredName}
                    </div>
                    <div style={{ fontSize: 10, color: "#646D69" }}>
                      {_render_quan_he(data?.relationshipWithBuyerName)} -{" "}
                      {data?.buyerDob || data?.insuredDob}
                    </div>
                  </div>
                  <div
                    style={{
                      textAlign: "left",
                      marginRight:
                        data?.relationshipWithBuyerName === 1 ? 28 : "",
                    }}
                  >
                    <div style={{ fontSize: 10, color: "#646D69" }}>
                      Phí bảo hiểm
                    </div>
                    <div style={{ fontWeight: 500 }}>
                      {Helper._formatMoney(
                        (
                          packages[+dataIsu?.packageId - 1]?.listFees || []
                        ).filter((v) => v.ten === data?.insuredName)[0]?.fees ||
                        0
                      )}{" "}
                      VNĐ/năm
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display:
                      data?.relationshipWithBuyerName === 1 ? "none" : "",
                  }}
                >
                  <img
                    onClick={() => {
                      setOpenViewDetail(true);
                      setIndexDetail(i);
                    }}
                    style={{ width: 18, marginLeft: 10 }}
                    src={IViewDetail}
                    alt="Global Care"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {token && collaboratorInfo && (
          <>
            <div style={css.driver}></div>
            <div style={{ padding: 10 }}>
              <div style={css.title}>Thông tin cộng tác viên</div>
              <div style={css.item}>
                <div style={{ color: "#646D69" }}>Họ và tên:</div>
                <div style={{ fontWeight: 500, textAlign: "right" }}>{collaboratorInfo.fullname || "---"}</div>
              </div>
              <div style={css.item}>
                <div style={{ color: "#646D69" }}>Mã số thuế:</div>
                <div style={{ fontWeight: 500, textAlign: "right" }}>{collaboratorInfo.taxCode || "---"}</div>
              </div>
            </div>
          </>
        )}

        <div style={css.driver}></div>
        <div style={{ padding: 10 }}>
          <div style={css.title}>Thông tin xuất hoá đơn</div>
          <div style={{ marginTop: 10 }}>
            <div>Lựa chọn xuất hóa đơn VAT?</div>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập thông tin xuất hoá đơn",
                },
              ]}
              name="vat"
              style={css.FormItemsHolder}
            >
              <Radio.Group
                onChange={(e) => {
                  onChangForm({ data: e.target.value, name: "vat" });
                  setDataIsu({ ...dataIsu, vat: e.target.value });
                  localStorage.setItem(
                    "dataIsuVbiCare",
                    JSON.stringify({ ...dataIsu, vat: e.target.value })
                  );
                  if (e.target.value === 1) {
                    localStorage.removeItem("vatVBICare");
                    setVAT({});
                  }
                }}
              >
                <Radio value={1}>Không</Radio>
                <Radio value={2}>Có</Radio>
              </Radio.Group>
            </Form.Item>
          </div>
          <div
            style={{
              margintop: 10,
              background: "#F8F9F9",
              padding: 10,
              borderRadius: 4,
              display: dataIsu?.vat === 2 ? "" : "none",
            }}
          >
            <div style={{ marginBottom: 10, display: vat?.name ? "none" : "" }}>
              Bạn cần bổ sung thông tin hóa đơn trước khi xuất hóa đơn.
            </div>
            <div
              style={{
                padding: 7,
                color: vat?.name ? "#009B4B" : "#F58220",
                fontWeight: 600,
                border: vat?.name ? "1px solid #009B4B" : "1px solid #F58220",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 4,
              }}
              onClick={() => setOpenVat(true)}
            >
              <img
                style={{ width: 18, marginRight: 5 }}
                src={vat?.name ? IvatTrue : Ivat}
                alt="Global Care"
              />
              {vat?.name ? "Thông tin hoá đơn" : "Bổ sung thông tin hóa đơn"}
            </div>
          </div>
        </div>
        <div style={css.driver}></div>
        <div style={{ padding: 10 }}>
          {(["app", "zalo_mini"].includes(platform) && subsidyAmount > 0) && (<div style={{ marginBottom: 15 }}>
            <div style={css.titleInput}>Khoản trợ giá</div>
            <div style={{ position: 'relative' }}>
              <Input
                autoComplete="off"
                inputMode="numeric"
                style={{ ...css.input, paddingRight: 120 }}
                placeholder="Nhập số tiền trợ giá"
                value={subsidy ? Helper._formatMoney(subsidy) : ''}
                onChange={(e) => {
                  const raw = e.target.value.replace(/\./g, '').replace(/,/g, '');
                  const num = parseInt(raw, 10);
                  if (isNaN(num) || num <= 0) {
                    setSubsidy(0);
                    setIsMaxSubsidy(false);
                    return;
                  }
                  if (num >= subsidyAmount) {
                    setSubsidy(subsidyAmount);
                    setIsMaxSubsidy(true);
                  } else {
                    setSubsidy(num);
                    setIsMaxSubsidy(false);
                  }
                }}
              />
              <div style={{
                position: 'absolute',
                right: 8,
                top: '50%',
                transform: 'translateY(-50%)',
                display: 'flex',
                alignItems: 'center',
                gap: 6,
              }}>
                <span style={{ color: '#646D69', fontSize: 14 }}>VNĐ</span>
                {subsidy > 0 && (
                  <CloseOutlined
                    onClick={() => { setSubsidy(0); setIsMaxSubsidy(false); }}
                    style={{ cursor: 'pointer', color: '#646D69', fontSize: 14, marginRight: 2 }}
                  />
                )}
                <span
                  onClick={() => {
                    if (!isMaxSubsidy) {
                      setSubsidy(subsidyAmount);
                      setIsMaxSubsidy(true);
                    }
                  }}
                  style={{
                    cursor: isMaxSubsidy ? 'not-allowed' : 'pointer',
                    background: isMaxSubsidy ? '#d9d9d9' : '#F0F2F5',
                    border: isMaxSubsidy ? '1px solid #d9d9d9' : '1px solid #D2D2D2',
                    borderRadius: 6,
                    padding: '6px 8px',
                    color: isMaxSubsidy ? '#999' : '#343A40',
                    fontWeight: 700,
                    fontSize: 12,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 3,
                    whiteSpace: 'nowrap',
                  }}
                >
                  <img src={IconArrow} alt="Tối đa" style={{ height: 16, width: 16 }} /> Tối đa
                </span>
              </div>
            </div>
            <div style={{ color: '#F58220', fontSize: 12, marginTop: 4, fontStyle: 'italic' }}>
              Khoản trợ giá tối đa: <b>{Helper._formatMoney(subsidyAmount)} </b>VNĐ
            </div>
          </div>)}
          <div>
            <div style={css.titleInput}>Mã ưu đãi</div>
            <div
              style={{
                display: "flex",
                width: "100%",
                alignItems: "flex-start",
                justifyContent: "space-between",
              }}
            >
              <div style={{ width: "75%" }}>
                <Form.Item
                  name="redeem"
                  rules={[
                    {
                      required: false,
                      message: "Vui lòng nhập mã ưu đãi của bạn.",
                    },
                  ]}
                  style={{
                    width: "100%",
                    borderRadius: 8,
                    margin: "0px 0px 5px 0px",
                    padding: 0,
                  }}
                >
                  <Input
                    autoComplete="off"
                    name="redeem"
                    style={{ ...css.input }}
                    prefix={<img width={18} src={Iticket} alt="quyen loi" />}
                    placeholder="Nhập mã ưu đãi"
                    // disabled={dataCheckReDeem?.code ? true : false}
                    onChange={(e) => {
                      onChangForm({
                        data: e.target.value,
                        name: e.target.name,
                      });
                      // setUseRedeem(false);
                    }}
                  />
                </Form.Item>
              </div>
              <div style={{ width: "80px" }}>
                <div
                  onClick={() => {
                    if (form.getFieldValue("redeem")) {
                      setErrRedeem("Áp dụng mã ưu đãi không khả dụng");
                    }
                    // if (formData?.redeem) {
                    //   setUseRedeem(true);
                    //   checkReem();
                    // } else {
                    //   setUseRedeem(false);
                    // }
                  }}
                  style={
                    form.getFieldValue("redeem")
                      ? css.buttonRedeem
                      : css.buttonRedeemDisabled
                  }
                >
                  Áp dụng
                </div>
              </div>
            </div>
            <div
              style={{
                color: "red",
                display: errRedeem ? "" : "none",
              }}
            >
              {errRedeem}
            </div>
            {/* <div
                  style={{
                    color: !dataCheckReDeem?.code ? "red" : "green",
                    display: dataCheckReDeem ? "" : "none",
                  }}
                >
                  {!dataCheckReDeem?.code
                    ? "Áp dụng mã giảm giá không khả dụng"
                    : "Áp dụng mã giảm giá thành công"}
                </div> */}
          </div>
          <div
            style={{
              marginTop: 10,
              borderRadius: 4,
              border: "1px solid #009B4B",
              padding: 10,
              lineHeight: 2,
              marginBottom: 15,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Tổng phí bảo hiểm:</span>
              <span>
                {Helper._formatMoney(
                  packages[+dataIsu?.packageId - 1]?.fees || 0
                )}{" "}
                VNĐ
              </span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Ưu đãi:</span>
              <span>0 VNĐ</span>
            </div>
            {["app", "zalo_mini"].includes(platform) && subsidyAmount > 0 && (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>Trợ giá:</span>
                <span>{`${Helper._formatMoney(subsidy)} VNĐ`}</span>
              </div>
            )}
            {showReward && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ width: "150px" }}>Áp dụng tiền thưởng</div>
                <div>-{Helper._formatMoney(reward || 0)} VNĐ</div>
              </div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: 500,
                fontSize: 16,
              }}
            >
              <span>Tổng tiền thanh toán:</span>
              <span style={{ color: "#009B4B" }}>
                <b>
                  {Helper._formatMoney(
                    Math.max(0, (packages[+dataIsu?.packageId - 1]?.fees || 0) -
                      (reward || 0) - (subsidy || 0))
                  )}{" "}
                  VNĐ
                </b>
              </span>
            </div>
          </div>
          {["app", "zalo_mini"].includes(platform) && (
            <div
              style={{
                margin: "10px 0px",
                borderRadius: 4,
                border: "1px solid #F58220",
                padding: 10,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: 500,
                  fontSize: 16,
                }}
              >
                <span>Lương doanh thu:</span>
                <span style={{ color: "#F58220" }}>
                  <b>{Helper._formatMoney(Math.max(0, commission - (subsidy || 0)))} VNĐ</b>
                </span>
              </div>
            </div>
          )}
        </div>
        <div style={css.driver}></div>
        <div style={{ padding: 10 }}>
          <style>{`
            .consent-link {
              color: #0044CC !important;
              text-decoration: none !important;
              font-weight: 400 !important;
            }
            .consent-link:hover {
              color: #0033AA !important;
            }
          `}</style>
          <div>
            <Form.Item
              name="rules"
              rules={[
                {
                  required: true,
                  message: "Vui lòng đồng ý điều kiện, điều khoản.",
                },
              ]}
              style={css.FormItemsHolder}
            >
              <Checkbox.Group
                style={{ width: "100%" }}
              >
                <Checkbox value="rules">
                  <div style={{ color: "#646D69", fontWeight: 400 }}>
                    Tôi xác nhận thông tin kê khai là trung thực, đầy đủ; đã
                    đọc và đồng ý với{" "}
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        OpenLink("https://cdn.globalcare.vn/private/document/pdf/vbi-cares/vietinbank/Quy_tac_BH_VBI_care.pdf");
                      }}
                      className="consent-link"
                      style={{ color: '#0044CC', cursor: 'pointer', textDecoration: 'none', fontWeight: 400 }}
                    >
                      Quy tắc & Điều khoản sản phẩm bảo hiểm
                    </span>;{" "} đồng ý để Global Care và các đơn vị liên quan (cổng thanh toán, doanh nghiệp bảo hiểm) chia sẻ, sử dụng thông tin nhằm phát hành, quản lý hợp đồng, tư vấn và hỗ trợ dịch vụ.
                  </div>
                </Checkbox>
              </Checkbox.Group>
            </Form.Item>
          </div>
          <div style={{ marginTop: 10 }}>
            <Form.Item
              name="term"
              rules={[
                {
                  required: true,
                  message: "Vui lòng đồng ý điều kiện, điều khoản.",
                },
              ]}
              style={css.FormItemsHolder}
            >
              <Checkbox.Group
                style={{ width: "100%" }}
              >
                <Checkbox value="term">
                  <div style={{ color: "#646D69", fontWeight: 400 }}>
                    Tôi xác nhận{" "}
                    <span style={{ fontWeight: 600 }}>
                      là người được bảo hiểm hoặc đã được người được bảo hiểm ủy quyền hợp pháp
                    </span>{' '}
                    thực hiện giao dịch, và chịu trách nhiệm về tính chính xác của thông tin cũng như mọi khiếu nại liên quan.
                  </div>
                </Checkbox>
              </Checkbox.Group>
            </Form.Item>
          </div>
          <div style={{ fontSize: 12, color: "#BF272D", margin: "10px 0", textAlign: "left", fontWeight: 400 }}>
            Lưu ý: Khi chọn vào mục này, đồng nghĩa việc kê khai bảo hiểm đã
            xong và quý khách không thể cập nhật lại.
          </div>
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "2%",
              }}
            >
              <b style={{ color: "#009B4B" }}>
                Chữ ký của bạn<span style={{ color: "red" }}>*</span>
              </b>
              <b
                onClick={() => setClear(true)}
                style={{ color: "#E16C2B", textDecoration: "underline" }}
              >
                Ký lại
              </b>
            </div>
            <div
              style={{
                border: "1px solid #DDDDDD",
                borderRadius: 10,
                marginBottom: 106,
                minHeight: 159,
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Signater setClear={setClear} clear={clear} />
            </div>
          </div>
        </div>
        <Animated
          animationIn="fadeInUp"
          animationInDuration={500}
          isVisible={true}
          style={{ width: "100%", position: "fixed", bottom: 0 }}
        >
          <div style={css.boxbtn}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px 0px",
              }}
            >
              <span>Tổng tiền thanh toán</span>
              <span style={{ color: "#009B4B" }}>
                <b>
                  {Helper._formatMoney(
                    Math.max(0, (packages[+dataIsu?.packageId - 1]?.fees || 0) -
                      (reward || 0) - (subsidy || 0))
                  )}{" "}
                  VNĐ
                </b>
              </span>
            </div>
            <div style={css.divFlex}>
              <Button
                onClick={() => goStep(3)}
                style={css.btnBack}
                type="#009B4B"
              >
                Quay lại
              </Button>
              <Button
                loading={loading}
                htmlType="submit"
                style={css.btnNext}
                type="#009B4B"
              >
                Tiếp tục
              </Button>
            </div>
          </div>
        </Animated>
      </Form>
    </>
  );
};

const css = {
  divFlex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    fontSize: 16,
    color: "#009B4B",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  FormItemsHolder: {
    width: "100%",
    borderRadius: 8,
    margin: "5px 0px",
    padding: 0,
  },
  input: { borderRadius: 8, padding: 10, fontSize: 14, color: "#343A40" },
  driver: {
    width: "100%",
    height: 5,
    background: "#0000001A",
  },
  btnBack: {
    color: "#009B4B",
    background: "#FFF",
    fontWeight: "bold",
    width: "48%",
    height: "44px",
    borderRadius: 8,
    border: "1px solid #009B4B",
  },
  btnNext: {
    color: "#FFF",
    background: "#009B4B",
    fontWeight: "bold",
    width: "48%",
    height: "44px",
    borderRadius: 8,
  },
  itemRight: {
    color: "#009B4B",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    fontSize: 12,
  },
  item: { display: "flex", justifyContent: "space-between", marginTop: 10 },
  buttonRedeem: {
    cursor: "pointer",
    fontWeight: 600,
    background: "#F58220",
    borderRadius: 8,
    color: "#ffffff",
    textAlign: "center",
    padding: "9px 0px",
  },
  buttonRedeemDisabled: {
    cursor: "pointer",
    fontWeight: 600,
    background: "#808985",
    borderRadius: 8,
    color: "#FFFFFF",
    textAlign: "center",
    padding: "9px 0px",
    border: "1px solid #d9d9d9",
  },
  boxbtn: {
    position: "fixed",
    bottom: 0,
    height: 96,
    background: "#fff",
    borderRadius: "16px 16px 0px 0px",
    boxShadow: "0px -4px 8px 0px #0000001A",
    padding: "0px 10px",
    width: "100%",
  },
};

export default Create;
